module.exports = __webpack_public_path__ + "efd03bb5c2740e6a7ea04f9fea347e42.svg";